import React from "react"
import { SecondaryCenteredTextType } from "../../types/mainModulTypes"
import BaseRichtext from "../common/BaseRichtext"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseHeadline from "../common/BaseHeadline"

export default function SecondaryCenteredText(props: SecondaryCenteredTextType) {
    const getShade = (shade?: string): string => {
        if (shade?.includes("secondaryCenteredTextColorLight")) return "bg-base-200"
        if (shade?.includes("secondaryCenteredTextColorSuperLight")) return "bg-base-300"
        if (shade?.includes("secondaryCenteredTextColorWhite")) return "bg-accent"
        if (shade?.includes("secondaryCenteredTextColorPrimary")) return "bg-base-100"
        if (shade?.includes("secondaryCenteredTextColorOptional")) return "bg-info"
        return ""
    }

    return (
        <div
            className={`max-w-content  sm:mx-8 lg:mx-auto ${getShade(
                props?.secondaryCenteredTextColor
            )} flex flex-col justify-center items-center text-center py-12 px-4 md:px-6 lg:px-16 rounded-default `}>
            <BaseHeadline headlineType={3} label={props.secondaryCenteredTextHeading}  classProps="leading-10"/>
            <BaseSubheadline label={props.secondaryCenteredTextSubHeading} />
            <BaseRichtext content={props.secondaryCenteredText} classProps="pt-4" />
        </div>
    )
}
